const NetInfo = {
  fetch: () => Promise.resolve({ isConnected: true, isInternetReachable: true, type: 'wifi', details: null }),
  addEventListener: () => () => {},
  useNetInfo: () => ({ isConnected: true, isInternetReachable: true, type: 'wifi', details: null }),
  configure: () => {},
};

export const useNetInfo = () => ({ isConnected: true, isInternetReachable: true, type: 'wifi', details: null });
export const addEventListener = NetInfo.addEventListener;
export const fetch = NetInfo.fetch;
export const configure = NetInfo.configure;
export default NetInfo;
